module.exports = __webpack_public_path__ + "media/src/assets/Images/LogoFascioliNew-0664e961591fc7d38839ae4e270f7ef1.svg";